import {NativeModules} from 'react-native';
import {getSkywalkerSearchParams, getSectorInformation} from './util';

// add object type when search is refactored in ts
export const skywalkerSearchConnector = (data, pageName) => {
  const {GenericModule} = NativeModules;
  if (!GenericModule || !GenericModule.updateSearchEvents) {
    return;
  }

  GenericModule.updateSearchEvents('rails', getSkywalkerSearchParams(data, pageName));
};

export const skywalkerSectorConnector = (data, pageName) => {
  const {GenericModule} = NativeModules;
  if (!GenericModule || !GenericModule.updateSectorInfo) {
    return;
  }
  GenericModule.updateSectorInfo('rails', getSectorInformation(data, pageName));
};
